export default [
  {
    path: 'dailySettlement',
    component: () => import(/* webpackChunkName: "daily-settlement" */ '@/pages/scheduling/dailySettlement/TaskList'),
    meta: { title: '日结专区', cate: '排班打卡' },
    children: [
      {
        path: ':batch_id/send',
        component: () => import(/* webpackChunkName: "daily-settlement" */ '@/pages/scheduling/dailySettlement/BatchSend'),
        meta: {
          title: '生成表单',
        },
        hidden: true,
      },
      {
        path: ':batch_id/view',
        component: () => import(/* webpackChunkName: "daily-settlement" */ '@/pages/scheduling/dailySettlement/BatchDetail'),
        meta: { title: '查看明细' },
        hidden: true,
      },
      {
        path: ':batch_id/edit-amount/:detail_id',
        component: () => import(/* webpackChunkName: "daily-settlement" */ '@/pages/scheduling/dailySettlement/EditAmount'),
        meta: { title: '修改金额' },
        hidden: true,
      },
    ],
  },
  {
    path: 'shiftManage',
    component: () => import(/* webpackChunkName: "shift-manage" */ '@/pages/scheduling/ShiftManage'),
    meta: { title: '班次管理', cate: '排班打卡' }
  },
  {
    path: 'attendanceClockRecord',
    component: () => import(/* webpackChunkName: "attendance-clock-record" */ '@/pages/scheduling/AttendanceClockRecord'),
    meta: { title: '打卡记录', cate: '排班打卡' }
  },
  {
    path: 'attendanceClockStats',
    name: 'AttendanceClockStats',
    component: () => import(/* webpackChunkName: "attendance-clock-stats" */ '@/pages/scheduling/AttendanceClockStats'),
    meta: { title: '打卡统计', cate: '排班打卡' }
  }
]
